/**
 * Route for `publisher-dashboard-separate-persona-with-partner`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublisherDashboardSeparatePersonaWithPartnerPage } from "../features/publisher-dashboard-separate-persona-with-partner/PublisherDashboardSeparatePersonaWithPartnerPage";

export const publisherDashboardSeparatePersonaWithPartnerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-dashboard-separate-persona-with-partner",
	component: PublisherDashboardSeparatePersonaWithPartnerPage,
});

export default publisherDashboardSeparatePersonaWithPartnerRoute;
